const INITIAL_STATE = {
  token: "",
  customerId: "",
  customerCode: "",
  customerSiteId: 0,
  customerType: "",
  corporateName: "",
  document: "",
  commercialRegion: "",
  email: "",
  userId: "",
  customerAddresses: []
};

const userReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  if (type === "GET_USER_INFO") {
    return {
      ...state,
      token: action.token,
      customerId: action.userInfo.customerId,
      customerCode: action.userInfo.customerCode,
      customerSiteId: action.userInfo.customerSiteId,
      customerType: action.userInfo.customerType,
      corporateName: action.userInfo.corporateName,
      document: action.userInfo.document,
      commercialRegion: action.userInfo.commercialRegion,
      email: action.userInfo.email,
      userId: action.userInfo.userId,
      customerAddresses: action.userInfo.customerAddresses
    };
  } else if (type === "GET_USER_ID") {
    return {
      ...state,
      userId: action.userId
    };
  } else {
    return {
      ...state
    };
  }
};

export default userReducer;
